var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.loading
        ? _c("Loading", { attrs: { text: "Lebenslauf wird geladen..." } })
        : [
            _c(
              "div",
              { staticClass: "matching mb-4" },
              [
                _c("MatchingOverview", {
                  attrs: { matching: _vm.matching, "with-percentage": false }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm._t("after-matching-overview"),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "job-vita" },
              _vm._l(
                _vm.vita.grids.filter(function(g) {
                  return g.hasData
                }),
                function(grid) {
                  return _c("Grid", {
                    key: grid.id,
                    attrs: {
                      grid: grid,
                      "job-profile-id": _vm.jobProfileId,
                      "pseudonym-id": _vm.pseudonymId
                    },
                    on: { upgrade: _vm.loadVita }
                  })
                }
              ),
              1
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }